const o = ':host{display:inline-block}.sl-button{display:inline-flex;align-items:center;justify-content:center;gap:var(--sl-spacing-2);white-space:nowrap;border:none;border-radius:var(--sl-radius-md);font-family:var(--sl-font-family-base);font-size:var(--sl-font-size-sm);font-weight:var(--sl-font-weight-medium);line-height:1;text-decoration:none;cursor:pointer;transition:all var(--sl-transition-fast);outline:none}.sl-button:focus-visible{box-shadow:0 0 0 2px hsl(var(--sl-hsl-background)),0 0 0 4px hsl(var(--sl-hsl-ring))}.sl-button:disabled{cursor:not-allowed;opacity:0.5;pointer-events:none}.sl-button--default{background-color:hsl(var(--sl-hsl-primary));color:hsl(var(--sl-hsl-primary-foreground));box-shadow:var(--sl-shadow-sm)}.sl-button--default:hover:not(:disabled){opacity:0.9}.sl-button--destructive{background-color:hsl(var(--sl-hsl-destructive));color:hsl(var(--sl-hsl-destructive-foreground));box-shadow:var(--sl-shadow-sm)}.sl-button--destructive:hover:not(:disabled){opacity:0.9}.sl-button--outline{background-color:transparent;border:1px solid hsl(var(--sl-hsl-border));color:hsl(var(--sl-hsl-foreground))}.sl-button--outline:hover:not(:disabled){background-color:hsl(var(--sl-hsl-secondary));color:hsl(var(--sl-hsl-secondary-foreground))}.sl-button--secondary{background-color:hsl(var(--sl-hsl-secondary));color:hsl(var(--sl-hsl-secondary-foreground));box-shadow:var(--sl-shadow-sm)}.sl-button--secondary:hover:not(:disabled){opacity:0.8}.sl-button--ghost{background-color:transparent;color:hsl(var(--sl-hsl-foreground))}.sl-button--ghost:hover:not(:disabled){background-color:hsl(var(--sl-hsl-secondary));color:hsl(var(--sl-hsl-secondary-foreground))}.sl-button--link{background-color:transparent;color:hsl(var(--sl-hsl-primary));text-decoration:underline;text-underline-offset:4px}.sl-button--link:hover:not(:disabled){color:hsl(var(--sl-hsl-primary-700))}.sl-button--default,.sl-button--destructive,.sl-button--outline,.sl-button--secondary,.sl-button--ghost,.sl-button--link{height:2.25rem;padding:0 var(--sl-spacing-4)}.sl-button--xs{height:1.75rem;padding:0 var(--sl-spacing-2);border-radius:var(--sl-radius-sm);font-size:var(--sl-font-size-xs)}.sl-button--sm{height:2rem;padding:0 var(--sl-spacing-3);border-radius:var(--sl-radius-md);font-size:var(--sl-font-size-xs)}.sl-button--lg{height:2.5rem;padding:0 var(--sl-spacing-8);border-radius:var(--sl-radius-md);font-size:var(--sl-font-size-base)}.sl-button--icon,.sl-button--icon-only{height:2.25rem;width:2.25rem;padding:0}.sl-button__icon{flex-shrink:0;width:1rem;height:1rem}.sl-button--icon-only .sl-button__icon{width:1.25rem;height:1.25rem}.sl-button__label{display:inline-block}:host([data-group-position]) .sl-button{border-radius:0}:host([data-group-position="first"][data-group-orientation="horizontal"]) .sl-button{border-radius:var(--sl-radius-md) 0 0 var(--sl-radius-md)}:host([data-group-position="last"][data-group-orientation="horizontal"]) .sl-button{border-radius:0 var(--sl-radius-md) var(--sl-radius-md) 0}:host([data-group-position="first"][data-group-orientation="vertical"]) .sl-button{border-radius:var(--sl-radius-md) var(--sl-radius-md) 0 0}:host([data-group-position="last"][data-group-orientation="vertical"]) .sl-button{border-radius:0 0 var(--sl-radius-md) var(--sl-radius-md)}:host([data-group-position="only"]) .sl-button{border-radius:var(--sl-radius-md)}:host([data-group-orientation="vertical"]) .sl-button{width:100%}.sl-button--checked{background-color:hsl(var(--sl-hsl-primary));color:hsl(var(--sl-hsl-primary-foreground));box-shadow:var(--sl-shadow-sm)}.sl-button--checked:hover:not(:disabled){opacity:0.9}';
class i extends HTMLElement {
  static get observedAttributes() {
    return ["variant", "size", "disabled", "type", "icon", "icon-position", "label", "value", "checked"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._button = document.createElement("button"), this._boundHandleClick = this._handleClick.bind(this), this._render();
  }
  connectedCallback() {
    this._button = this._shadow.querySelector("button"), this._button.addEventListener("click", this._boundHandleClick);
  }
  disconnectedCallback() {
    this._button.removeEventListener("click", this._boundHandleClick);
  }
  attributeChangedCallback(t, s, e) {
    s !== e && (this._updateButton(), this._render());
  }
  _handleClick(t) {
    t.stopPropagation(), this.dispatchEvent(
      new CustomEvent("click", {
        bubbles: !0,
        composed: !0,
        detail: { originalEvent: t }
      })
    );
  }
  get variant() {
    return this.getAttribute("variant") || "default";
  }
  set variant(t) {
    this.setAttribute("variant", t);
  }
  get size() {
    return this.getAttribute("size") || "default";
  }
  set size(t) {
    this.setAttribute("size", t);
  }
  get disabled() {
    return this.hasAttribute("disabled");
  }
  set disabled(t) {
    t ? this.setAttribute("disabled", "") : this.removeAttribute("disabled");
  }
  get type() {
    return this.getAttribute("type") || "button";
  }
  set type(t) {
    this.setAttribute("type", t);
  }
  get icon() {
    return this.getAttribute("icon");
  }
  set icon(t) {
    t ? this.setAttribute("icon", t) : this.removeAttribute("icon");
  }
  get iconPosition() {
    return this.getAttribute("icon-position") || "left";
  }
  set iconPosition(t) {
    this.setAttribute("icon-position", t);
  }
  get label() {
    return this.getAttribute("label");
  }
  set label(t) {
    t ? this.setAttribute("label", t) : this.removeAttribute("label");
  }
  get value() {
    return this.getAttribute("value");
  }
  set value(t) {
    t ? this.setAttribute("value", t) : this.removeAttribute("value");
  }
  get checked() {
    return this.hasAttribute("checked");
  }
  set checked(t) {
    t ? this.setAttribute("checked", "") : this.removeAttribute("checked");
  }
  _updateButton() {
    this._button.type = this.type, this._button.disabled = this.disabled, this._button.className = this._getButtonClasses();
  }
  _getButtonClasses() {
    const t = [
      "sl-button",
      `sl-button--${this.variant}`,
      `sl-button--${this.size}`
    ];
    return this.disabled && t.push("sl-button--disabled"), this.checked && t.push("sl-button--checked"), this.icon && !this.label && !this.textContent?.trim() && t.push("sl-button--icon-only"), t.join(" ");
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${o}</style>
      <button
        type="${this.type}"
        class="${this._getButtonClasses()}"
        ?disabled="${this.disabled}"
      >
        ${this._renderIcon("left")}
        ${this._renderContent()}
        ${this._renderIcon("right")}
      </button>
    `, this._button = this._shadow.querySelector("button"), this._button.addEventListener("click", this._boundHandleClick);
  }
  _renderIcon(t) {
    return !this.icon || this.iconPosition !== t ? "" : `<sl-icon name="${this.icon}" class="sl-button__icon"></sl-icon>`;
  }
  _renderContent() {
    return this.label ? `<span class="sl-button__label">${this.label}</span>` : "<slot></slot>";
  }
  focus() {
    this._button.focus();
  }
  blur() {
    this._button.blur();
  }
  click() {
    this._button.click();
  }
}
typeof customElements < "u" && !customElements.get("sl-button") && customElements.define("sl-button", i);
export {
  i as SlButtonElement
};
//# sourceMappingURL=sl-button.js.map
